import { useBooleanFlagValue } from '@openfeature/react-sdk';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { usePermissions } from '@/entities/user';
import { IdentityPlatformIcon } from '@/shared/ui/Icons';

import { FormSection, PersonaTextField } from '../../PersonaFormSections';
import { useEditPersonaFormContext } from '../hooks/useEditPersonaFormContext';

export function GwiLinkSection() {
  const { t } = useTranslation('audiences');

  const { control } = useEditPersonaFormContext();
  const flagOn = useBooleanFlagValue('gwi_audience_linking', false);
  const { canAccessGwiIntegration } = usePermissions();

  if (!flagOn || !canAccessGwiIntegration) return null;

  return (
    <FormSection icon={<IdentityPlatformIcon />} title={t('audiences.gwiLinkSection.gwiAudience')}>
      <Controller
        name="gwiId"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <PersonaTextField
            {...field}
            label={t('audiences.gwiLinkSection.gwiAudienceId')}
            placeholder={t('audiences.gwiLinkSection.eG06e243bcD5244d16')}
            description={t('audiences.gwiLinkSection.pasteTheGwiAudienceUuid')}
            error={error?.message}
          />
        )}
      />
    </FormSection>
  );
}
